import { createStore, applyMiddleware } from 'redux';
import { devToolsEnhancer } from 'redux-devtools-extension';
import { compose } from 'recompose';
import thunk from 'redux-thunk';


import rootReducer from './features/reducer';


/*
* TODO: Consider if we should disable redux devtools in production.
* see: redux-devtools-extension/developmentOnly
 */
const configureStore = (extraArgument) => {
  const middleware = [thunk.withExtraArgument(extraArgument)];
  const enhancers = compose(
    applyMiddleware(...middleware),
    devToolsEnhancer(),
  );

  const store = createStore(rootReducer, undefined, enhancers);
  return store;
};


export default configureStore;
